import { render, staticRenderFns } from "./PrivateTemplates.vue?vue&type=template&id=68ca750d&scoped=true&"
import script from "./PrivateTemplates.vue?vue&type=script&lang=js&"
export * from "./PrivateTemplates.vue?vue&type=script&lang=js&"
import style0 from "./PrivateTemplates.vue?vue&type=style&index=0&id=68ca750d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ca750d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VProgressCircular})
